import { Button } from "../../Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCrown,
    faMagnifyingGlassChart, // Using a more descriptive icon for keywords/analysis
    faBrain,
} from "@fortawesome/free-solid-svg-icons";

interface Props {
    onClose: () => void;
    onNext: () => void;
}

const steps = [
    {
        icon: faCrown,
        bgColor: "bg-blue-500",
        title: "1. Aan de slag",
        description: "Door nu in 1 minuut je account in te richten, kunnen we de voor jouw meest passende en interessante overheidsopdrachten tonen en per e-mail versturen.",
    },
    {
        icon: faMagnifyingGlassChart,
        bgColor: "bg-green-500",
        title: "2. Trefwoorden",
        description: "Op de volgende pagina omschrijf je binnen minimaal 5 en maximaal 10 trefwoorden wat je bedrijf doet. Zorg dat deze zo accuraat mogelijk zijn voor het beste resultaat.",
    },
    {
        icon: faBrain,
        bgColor: "bg-orange-500",
        title: "3. Artificial Intelligence (AI)",
        description: "Onze slimme AI bot (TenderAI) zoekt 24/7 naar de meest passende overheidsopdrachten en aanbestedingen voor jouw bedrijf.",
    },
];

export default function WelcomeOnboarding({ onClose, onNext }: Props) {
    return (
        <div className="w-full flex flex-col items-center justify-between p-6 sm:p-8 min-h-[70vh] md:min-h-[450px] overflow-y-auto">
            <div className="w-full max-w-lg space-y-8 overflow-y-auto max-h-[60vh]">
                {steps.map((step, index) => (
                    <div
                        key={index}
                        className="flex items-start space-x-4 animate-fadeInUp opacity-0"
                        style={{ animationDelay: `${index * 0.2}s`, animationFillMode: 'forwards' }}
                    >
                        <div
                            className={`flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center text-white ${step.bgColor}`}
                        >
                            <FontAwesomeIcon icon={step.icon} size="lg" />
                        </div>
                        <div>
                            <h3 className="text-lg font-semibold text-gray-800">{step.title}</h3>
                            <p className="text-sm text-gray-600 mt-1">{step.description}</p>
                        </div>
                    </div>
                ))}
            </div>
            <Button onClick={onNext} type="pink" className="mt-10 mb-2 sm:mb-4">
                Verder gaan
            </Button>
        </div>
    );
}
